(function () {
  'use strict';

  function addToCart(variantId, button) {
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Lägger till...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed');
        return res.json();
      })
      .then(function () {
        button.textContent = 'Tillagd ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () {
          button.disabled = false;
          button.textContent = originalText;
        }, 2500);
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = 'Försök igen';
        setTimeout(function () {
          button.textContent = originalText;
        }, 2000);
      });
  }

  function init() {
    document.querySelectorAll('[data-cart-rec-add]').forEach(function (button) {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', function () {
        var variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;
        addToCart(variantId, button);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind if the cart drawer re-renders this section dynamically
  document.addEventListener('cart:refresh', init);
  document.addEventListener('cart:updated', init);
})();